import React, { useState, useEffect } from "react";

export function Tarjeta({ titulo, valor, icono, colorFondo, colorTexto }) {
  const [valorActual, setValorActual] = useState(0);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setValorActual((prevValor) =>
        prevValor >= valor ? valor : prevValor + 20
      );
    }, 20);

    return () => clearInterval(intervalo);
  }, [valor]);

  return (
    <div
      className="relative p-6 rounded-2xl flex flex-col justify-center items-center flex-grow min-h-[220px] min-w-[280px] overflow-hidden group"
      style={{
        background: colorFondo
          ? `linear-gradient(135deg, ${colorFondo} 0%, ${colorFondo}dd 100%)`
          : "linear-gradient(135deg, #111827 0%, #1F2937 100%)",
        color: colorTexto || "#FFFFFF",
      }}
    >
      {/* Decorative Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full translate-y-1/2 -translate-x-1/2" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center">
        <h3
          className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4"
          style={{ color: colorTexto || "#FFFFFF" }}
        >
          {titulo}
        </h3>
        <div className="flex items-center justify-center gap-3">
          <span
            className="text-3xl sm:text-4xl md:text-5xl font-bold"
            style={{ color: colorTexto || "#FFFFFF" }}
          >
            {valorActual}
          </span>
          {icono && (
            <i
              className={`${icono} text-2xl sm:text-3xl md:text-4xl opacity-80`}
              style={{ color: colorTexto || "#FFFFFF" }}
            />
          )}
        </div>
      </div>

      {/* Hover Effect */}
      <div className="absolute inset-0 bg-white/0 group-hover:bg-white/10 transition-all duration-300" />
    </div>
  );
}
